/**
 * ShareErrorPage — 외부공유 접속 오류 공통 페이지 (F-04 §8.2)
 *
 * 외부 수신자용. 인증 불필요(공개 라우트), API 호출 없이 reason 파라미터만 읽어 정적 렌더.
 * ShareGate가 검증 실패 시 302 → /share-error?reason=CODE.
 * reason: EXPIRED / REVOKED / USED / AUTH_FAILED / NOT_FOUND
 *
 * TODO: reason별 안내 문구·디자인은 추후. 현재는 골격(코드 표시).
 */
import { useSearchParams } from 'react-router';

export function ShareErrorPage() {
  const [params] = useSearchParams();
  const reason = params.get('reason') ?? 'UNKNOWN';

  return (
    <div className="flex h-full min-h-screen flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-lg font-bold text-text">공유 링크에 접속할 수 없습니다</h1>
      <p className="mt-1 text-sm text-text-muted">reason: {reason}</p>
    </div>
  );
}
